import { Container } from "@chakra-ui/react";
import { Tooltip } from "./ui/tooltip";
import { useEffect, useRef, useState } from "react";

type TruncatedTextProps = {
    text: string;
};

export const TruncatedText = ({ text }: TruncatedTextProps) => {
    const textElementRef = useRef<HTMLDivElement | null>(null);

    const compareSize = () => {
        const scrollWidth = textElementRef?.current?.scrollWidth;
        const clientWidth = textElementRef?.current?.clientWidth;

        if (!scrollWidth || !clientWidth) {
            return;
        }
        const compare = scrollWidth > clientWidth;
        setHoverStatus(compare);
    };

    useEffect(() => {
        compareSize();
        window.addEventListener("resize", compareSize);
    }, []);

    useEffect(
        () => () => {
            window.removeEventListener("resize", compareSize);
        },
        []
    );

    const [hoverStatus, setHoverStatus] = useState(false);

    return (
        <Tooltip content={text} disabled={!hoverStatus}>
            <Container
                ref={textElementRef}
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                p="0"
                m="0"
                h="100%"
                w="100%"
                minH="16px"
            >
                {text}
            </Container>
        </Tooltip>
    );
};
